export interface ICountryList {
  value: string;
  label: string;
}

/**
 * Country List sorted alphabetically by Icelandic country names (labels)
 * 
 * Each country object contains:
 * - value: ISO 3166-1 alpha-2 country code
 * - label: Country name in Icelandic
 */
export const CountryList: ICountryList[] = [
  { value: "AF", label: "Afganistan" },
  { value: "AL", label: "Albanía" },
  { value: "DZ", label: "Alsír" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angóla" },
  { value: "AI", label: "Angvilla" },
  { value: "AG", label: "Antígva og Barbúda" },
  { value: "AR", label: "Argentína" },
  { value: "AM", label: "Armenía" },
  { value: "AW", label: "Arúba" },
  { value: "AZ", label: "Aserbaídsjan" },
  { value: "AX", label: "Álandseyjar" },
  { value: "AU", label: "Ástralía" },
  { value: "TL", label: "Austur-Tímor" },
  { value: "AT", label: "Austurríki" },
  { value: "BS", label: "Bahamaeyjar" },
  { value: "BH", label: "Barein" },
  { value: "BB", label: "Barbados" },
  { value: "BD", label: "Bangladess" },
  { value: "BE", label: "Belgía" },
  { value: "BZ", label: "Belís" },
  { value: "BJ", label: "Benín" },
  { value: "BM", label: "Bermúdaeyjar" },
  { value: "BQ", label: "Bonaire, Sint Eustatius og Saba" },
  { value: "BA", label: "Bosnía og Hersegóvína" },
  { value: "BW", label: "Botsvana" },
  { value: "BV", label: "Bouveteyja" },
  { value: "BR", label: "Brasilía" },
  { value: "GB", label: "Bretland" },
  { value: "IO", label: "Bresku Indlandshafseyjar" },
  { value: "VG", label: "Bresku Jómfrúaeyjar" },
  { value: "BN", label: "Brúnei" },
  { value: "BG", label: "Búlgaría" },
  { value: "BF", label: "Búrkína Fasó" },
  { value: "BI", label: "Búrúndí" },
  { value: "BT", label: "Bútan" },
  { value: "BO", label: "Bólivía" },
  { value: "AS", label: "Bandaríska Samóa" },
  { value: "US", label: "Bandaríkin" },
  { value: "UM", label: "Bandarísku ytri eyjar" },
  { value: "VI", label: "Bandarísku Jómfrúaeyjar" },
  { value: "KY", label: "Caymaneyjar" },
  { value: "CL", label: "Chile" },
  { value: "CK", label: "Cookseyjar" },
  { value: "CW", label: "Cúracao" },
  { value: "DK", label: "Danmörk" },
  { value: "DJ", label: "Djíbútí" },
  { value: "DM", label: "Dóminíka" },
  { value: "DO", label: "Dóminíska lýðveldið" },
  { value: "EC", label: "Ekvador" },
  { value: "EG", label: "Egyptaland" },
  { value: "EE", label: "Eistland" },
  { value: "SV", label: "El Salvador" },
  { value: "ER", label: "Erítrea" },
  { value: "ET", label: "Eþíópía" },
  { value: "FR", label: "Frakkland" },
  { value: "GF", label: "Franska Gvæjana" },
  { value: "PF", label: "Franska Pólýnesía" },
  { value: "TF", label: "Frönsku suðlægu landsvæðin" },
  { value: "FO", label: "Færeyjar" },
  { value: "FK", label: "Falklandseyjar" },
  { value: "FJ", label: "Fídjieyjar" },
  { value: "PH", label: "Filippseyjar" },
  { value: "FI", label: "Finnland" },
  { value: "CI", label: "Fílabeinsströndin" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambía" },
  { value: "GH", label: "Gana" },
  { value: "GE", label: "Georgía" },
  { value: "GI", label: "Gíbraltar" },
  { value: "GR", label: "Grikkland" },
  { value: "GD", label: "Grenada" },
  { value: "GL", label: "Grænland" },
  { value: "CV", label: "Grænhöfðaeyjar" },
  { value: "GP", label: "Gvadelúpeyjar" },
  { value: "GU", label: "Gvam" },
  { value: "GT", label: "Gvatemala" },
  { value: "GY", label: "Gvæjana" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Gínea" },
  { value: "GW", label: "Gínea-Bissá" },
  { value: "HT", label: "Haítí" },
  { value: "HM", label: "Heard og McDonaldseyjar" },
  { value: "NL", label: "Holland" },
  { value: "HN", label: "Hondúras" },
  { value: "HK", label: "Hong Kong" },
  { value: "BY", label: "Hvíta-Rússland" },
  { value: "IN", label: "Indland" },
  { value: "ID", label: "Indónesía" },
  { value: "IQ", label: "Írak" },
  { value: "IR", label: "Íran" },
  { value: "IE", label: "Írland" },
  { value: "IS", label: "Ísland" },
  { value: "IL", label: "Ísrael" },
  { value: "IT", label: "Ítalía" },
  { value: "JM", label: "Jamaíka" },
  { value: "JP", label: "Japan" },
  { value: "YE", label: "Jemen" },
  { value: "JE", label: "Jersey" },
  { value: "CX", label: "Jólaeyja" },
  { value: "JO", label: "Jórdanía" },
  { value: "KH", label: "Kambódía" },
  { value: "CM", label: "Kamerún" },
  { value: "CA", label: "Kanada" },
  { value: "KZ", label: "Kasakstan" },
  { value: "QA", label: "Katar" },
  { value: "KE", label: "Kenía" },
  { value: "CN", label: "Kína" },
  { value: "KG", label: "Kirgistan" },
  { value: "KI", label: "Kíribatí" },
  { value: "CC", label: "Kókoseyjar" },
  { value: "KM", label: "Kómoreyjar" },
  { value: "XK", label: "Kosóvó" },
  { value: "CR", label: "Kostaríka" },
  { value: "CO", label: "Kólumbía" },
  { value: "HR", label: "Króatía" },
  { value: "CU", label: "Kúba" },
  { value: "KW", label: "Kúveit" },
  { value: "CY", label: "Kýpur" },
  { value: "LA", label: "Laos" },
  { value: "LS", label: "Lesótó" },
  { value: "LV", label: "Lettland" },
  { value: "LB", label: "Líbanon" },
  { value: "LR", label: "Líbería" },
  { value: "LY", label: "Líbýa" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Litháen" },
  { value: "LU", label: "Lúxemborg" },
  { value: "CD", label: "Lýðstjórnarlýðveldið Kongó" },
  { value: "CG", label: "Lýðveldið Kongó" },
  { value: "MO", label: "Makaó" },
  { value: "MG", label: "Madagaskar" },
  { value: "MY", label: "Malasía" },
  { value: "MW", label: "Malaví" },
  { value: "MV", label: "Maldíveyjar" },
  { value: "ML", label: "Malí" },
  { value: "MT", label: "Malta" },
  { value: "MA", label: "Marokkó" },
  { value: "MH", label: "Marshalleyjar" },
  { value: "MQ", label: "Martiník" },
  { value: "YT", label: "Mayotte" },
  { value: "MX", label: "Mexíkó" },
  { value: "FM", label: "Míkrónesía" },
  { value: "GQ", label: "Miðbaugs-Gínea" },
  { value: "CF", label: "Mið-Afríkulýðveldið" },
  { value: "MM", label: "Mjanmar" },
  { value: "MD", label: "Moldóva" },
  { value: "MN", label: "Mongólía" },
  { value: "MS", label: "Montserrat" },
  { value: "MZ", label: "Mósambík" },
  { value: "MC", label: "Mónakó" },
  { value: "IM", label: "Mön" },
  { value: "MR", label: "Máritanía" },
  { value: "MU", label: "Máritíus" },
  { value: "NA", label: "Namibía" },
  { value: "NR", label: "Nárú" },
  { value: "NP", label: "Nepal" },
  { value: "NI", label: "Níkaragva" },
  { value: "NE", label: "Níger" },
  { value: "NG", label: "Nígería" },
  { value: "NU", label: "Niue" },
  { value: "KP", label: "Norður-Kórea" },
  { value: "MK", label: "Norður-Makedónía" },
  { value: "MP", label: "Norður-Maríanaeyjar" },
  { value: "NF", label: "Norfolkeyja" },
  { value: "NO", label: "Noregur" },
  { value: "NC", label: "Nýja Kaledónía" },
  { value: "NZ", label: "Nýja Sjáland" },
  { value: "OM", label: "Óman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palá" },
  { value: "PS", label: "Palestína" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papúa Nýja-Gínea" },
  { value: "PY", label: "Paragvæ" },
  { value: "PE", label: "Perú" },
  { value: "PN", label: "Pitcairn" },
  { value: "PL", label: "Pólland" },
  { value: "PT", label: "Portúgal" },
  { value: "PR", label: "Púertó Ríkó" },
  { value: "RE", label: "Réunion" },
  { value: "RU", label: "Rússland" },
  { value: "RW", label: "Rúanda" },
  { value: "RO", label: "Rúmenía" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marínó" },
  { value: "ST", label: "Saó Tóme og Prinsípe" },
  { value: "AE", label: "Sameinuðu arabísku furstadæmin" },
  { value: "BL", label: "Sankti Bartólómeusareyja" },
  { value: "SH", label: "Sankti Helena" },
  { value: "KN", label: "Sankti Kitts og Nevis" },
  { value: "LC", label: "Sankti Lúsía" },
  { value: "MF", label: "Sankti Martin (franski hlutinn)" },
  { value: "PM", label: "Sankti Pierre og Miquelon" },
  { value: "VC", label: "Sankti Vincent og Grenadíneyjar" },
  { value: "ZM", label: "Sambía" },
  { value: "SB", label: "Salómonseyjar" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbía" },
  { value: "SC", label: "Seychelleseyjar" },
  { value: "ZW", label: "Simbabve" },
  { value: "SG", label: "Singapúr" },
  { value: "SX", label: "Sint Maarten (hollenski hlutinn)" },
  { value: "SL", label: "Síerra Leóne" },
  { value: "SK", label: "Slóvakía" },
  { value: "SI", label: "Slóvenía" },
  { value: "SO", label: "Sómalía" },
  { value: "ES", label: "Spánn" },
  { value: "LK", label: "Srí Lanka" },
  { value: "AQ", label: "Suðurskautslandið" },
  { value: "GS", label: "Suður-Georgía og Suður-Sandvíkseyjar" },
  { value: "KR", label: "Suður-Kórea" },
  { value: "SS", label: "Suður-Súdan" },
  { value: "ZA", label: "Suður-Afríka" },
  { value: "SD", label: "Súdan" },
  { value: "SR", label: "Súrínam" },
  { value: "SJ", label: "Svalbarði og Jan Mayen" },
  { value: "ME", label: "Svartfjallaland" },
  { value: "SZ", label: "Svasíland" },
  { value: "CH", label: "Sviss" },
  { value: "SE", label: "Svíþjóð" },
  { value: "SY", label: "Sýrland" },
  { value: "SA", label: "Sádi-Arabía" },
  { value: "TJ", label: "Tadsjikistan" },
  { value: "TW", label: "Taívan" },
  { value: "TH", label: "Taíland" },
  { value: "TZ", label: "Tansanía" },
  { value: "CZ", label: "Tékkland" },
  { value: "TG", label: "Tógó" },
  { value: "TK", label: "Tókelá" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trínidad og Tóbagó" },
  { value: "TD", label: "Tsjad" },
  { value: "TN", label: "Túnis" },
  { value: "TV", label: "Túvalú" },
  { value: "TM", label: "Túrkmenistan" },
  { value: "TC", label: "Turks- og Caicoseyjar" },
  { value: "TR", label: "Tyrkland" },
  { value: "DE", label: "Þýskaland" },
  { value: "HU", label: "Ungverjaland" },
  { value: "UY", label: "Úrúgvæ" },
  { value: "UZ", label: "Úsbekistan" },
  { value: "UG", label: "Úganda" },
  { value: "UA", label: "Úkraína" },
  { value: "VU", label: "Vanúatú" },
  { value: "VA", label: "Vatíkanið" },
  { value: "VE", label: "Venesúela" },
  { value: "EH", label: "Vestur-Sahara" },
  { value: "VN", label: "Víetnam" },
  { value: "WF", label: "Wallis- og Fútúnaeyjar" },
];